import { render, staticRenderFns } from "./ForceUpdateDialog.vue?vue&type=template&id=4ed45a1b&scoped=true"
import script from "./ForceUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ForceUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./ForceUpdateDialog.vue?vue&type=style&index=0&id=4ed45a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed45a1b",
  null
  
)

export default component.exports